module.exports = __webpack_public_path__ + "static/img/solution_dig.3d6f7591.png";